/** where the menu keeps its settings in the browser (the console's variables, the key binds): one JSON value */
export const SETTINGS_STORAGE_KEY = "trenchio_config";
